import React from 'react';
import PropTypes from 'prop-types';

import * as S from './IconButtonStyles';

function IconButton({ children, position = 'left', icon, ...props }) {
  return (
    <S.Button type="button" {...props}>
      {position === 'left' && (
        <S.IconContainer>{icon ? icon() : <S.ArrowLeft />}</S.IconContainer>
      )}
      <S.Label>{children}</S.Label>
      {position === 'right' && (
        <S.IconContainer>{icon ? icon() : <S.ArrowRight />}</S.IconContainer>
      )}
    </S.Button>
  );
}

IconButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.number,
    PropTypes.any
  ]),
  position: PropTypes.string,
  icon: PropTypes.func
};

export default IconButton;
